import { render } from "./CellphoneResetPassword.vue?vue&type=template&id=6a11b9c3"
import script from "./CellphoneResetPassword.vue?vue&type=script&lang=js"
export * from "./CellphoneResetPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/tabibekhanevade-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__